import { useState, useEffect } from 'react';

type useDeviceWidthType = {
  width: number | null;
  height: number | null;
};
const useDeviceWidth = (): useDeviceWidthType => {
  const isClient = typeof window === 'object';
  const [windowSize, setWindowSize] = useState(getWindowSize);

  function getWindowSize(): useDeviceWidthType {
    return {
      width: isClient ? window.innerWidth : null,
      height: isClient ? window.innerHeight : null
    };
  }

  useEffect(() => {
    setWindowSize(getWindowSize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return windowSize;
};

export default useDeviceWidth;
